import { useState, useEffect, useMemo } from 'react';
import { feature as topo2geo } from 'topojson-client';

import useJsonData from '~/core/scripts/hooks/useJsonData';
import useCsvData from '~/core/scripts/hooks/useCsvData';
import { sortByKey } from '~/core/scripts/utils';

const toGeojson = (topojsonObj) => {
  if (!topojsonObj) {
    return null;
  }
  const key = Object.keys(topojsonObj.objects)[0];
  return topo2geo(topojsonObj, topojsonObj.objects[key]);
};

export default (lookup, dataMode) => {
  const [holidayData, setHolidayData] = useState(null);
  const holidayTopojson = useJsonData('holidayregions-small.topo.json');
  /*const holidayCsv = useCsvData('data/holidayregions_popularity_03.csv', ';', (row) => ({
    ...row,
    beliebtheit: +row.beliebtheit,
    table_name: row.table_name,
  })); */

  const holidayGeo = useMemo(() => toGeojson(holidayTopojson), [holidayTopojson]);

  useEffect(() => {
   // if (holidayCsv && holidayGeo && lookup && !holidayData) {
    if (holidayGeo && lookup && !holidayData) {
      holidayGeo.features = holidayGeo.features
        .map((feat) => {
          feat.properties.ags = feat.properties.ags.split(',');
          /*const matchingData = holidayCsv.find((h) => h.holidayregions_id === feat.properties.holidayregion_id) || {
            beliebtheit: 0,
            table_name: '',
          }; */

          const agsAbs = feat.properties.ags.reduce(
            (res, ags) => {
              res.abs += lookup[ags] ? lookup[ags].abs : 0;
              res.pop += lookup[ags] ? lookup[ags].pop : 0;
              res.absb += lookup[ags] ? lookup[ags].absb : 0;

              return res;
            },
            { abs: 0, pop: 0, absb: 0 }
          );

          const agsRel = (agsAbs.abs / agsAbs.pop) * 100000;
          const agsRelVal = agsRel < 0 ? 0 : agsRel;

          const agsRelb2 = (agsAbs.abs / agsAbs.absb) * 100 - 100;
          const agsRelb = agsAbs.abs === 0 && agsAbs.absb !== 0 ? -9999999999 : agsAbs.abs === 0 && agsAbs.absb === 0 ? 0 : agsRelb2;
          const changeSign = agsRelb > 0 ? '+' : '';

          feat.properties = {
            ...feat.properties,
           // beliebtheit: matchingData.beliebtheit,
           // table_name: matchingData.table_name,
            agsAbs: agsAbs.abs,
            agsPop: agsAbs.pop,
            agsRel: agsRelVal,
            agsAbsb: agsAbs.absb,
            agsDelta: agsRelb,
            changeSign: changeSign,
            beliebtheit: +feat.properties.beliebtheit,
            ags_name_kurz: feat.properties.ags_name_kurz,
            table_name: feat.properties.table_name,
          };

          feat.id = feat.properties.holidayregion_id ? feat.properties.holidayregion_id : feat.id;
          //feat.sortval = dataMode === 'sleepings' ?  matchingData.beliebtheit : agsRelVal;
          feat.sortval = dataMode === 'sleepings' ?  +feat.properties.beliebtheit : agsRelVal;

          return feat;
        })
        .sort(sortByKey('sortval', true));

      holidayGeo.features = holidayGeo.features.map((feat, index) => {
        if (index < 10) {
          feat.properties.rank = index + 1;
        }

        return feat;
      });

      // holidayGeo.features = holidayGeo.features.sort(sortByKey('sortval', false));

      setHolidayData(holidayGeo);
    }
  }, [holidayGeo, lookup, holidayData, dataMode]);
//}, [holidayGeo, holidayCsv, lookup, holidayData, dataMode]);

  return holidayData;
};
